import { createSlice } from "@reduxjs/toolkit";
import { toast } from "@/lib/toast";

export interface CounterState {
  compare: [] | any;
}

const initialState: CounterState = {
  compare: [],
};

export const compareSlice = createSlice({
  name: "compare",
  initialState,
  reducers: {
    addProductToCompare: (state, action) => {
      const product: any = state.compare.find(
        (item: any) => item === action.payload
      );

      if (state.compare.length >= 3) {
        toast.info("You can only compare up to 3 properties");
        return;
      }

      if (product) {
        // remove product from compare
        state.compare = state.compare.filter(
          (item: any) => item !== action.payload
        );
      } else {
        state.compare.push(action.payload);
      }
    },
    removeFromCompare: (state, action) => {
      state.compare = state.compare?.filter(
        (item: any) => item !== action.payload
      );
    },
  },
});

export const compareItem = (state: any) => state.compare.compare;
export const { addProductToCompare, removeFromCompare } = compareSlice.actions;

export default compareSlice.reducer;
